import { t } from '@bia-auction/shared-i18n';
import { Button, EmptyState } from '@bia-auction/ui';
import { Link } from '@tanstack/react-router';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '../lib/auth';
import { canOpen } from '../lib/roles';

/**
 * Where a route the operator lacks the permission for sends them (M19, audit O-06).
 *
 * Rendered **inside** `AppShell` rather than as a bare page: the operator is signed in and
 * perfectly entitled to be here, just not there. Keeping the nav means the next click is a
 * place they can actually go, instead of a dead end.
 */
export function ForbiddenPage() {
  const { state } = useAuth();
  // The overview is itself gated (`salesList`), so for the accounts most likely to land here —
  // a bidder who signed in on the admin origin — a fixed link to `/` would redirect straight
  // back to this page. Offer the first destination this account can actually open; `/help` is
  // open to every session, so there is always one.
  const home = canOpen(state.roles, '/') ? '/' : '/help';

  return (
    <EmptyState
      icon={ShieldOff}
      title={t('forbidden.title')}
      description={t('forbidden.body')}
      // Filled, not outline: docs/15 §2 wants one primary action per screen, and this is it.
      action={
        <Button asChild size="sm">
          <Link to={home}>{home === '/' ? t('forbidden.home') : t('nav.help')}</Link>
        </Button>
      }
    />
  );
}
